import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cc-skeletons',
  templateUrl: './skeletons.component.html',
  styleUrls: ['./skeletons.component.scss'],
})
export class SkeletonsComponent implements OnInit {

  @Input() type;

  constructor() { }

  ngOnInit() { }

}
